import * as React from 'react';
import { Image, FlatList, Text, View, StyleSheet, Platform, Pressable, Share, useWindowDimensions } from 'react-native';
import * as AppUtilities from "../context/AppUtilities";
import * as AppConstants from "../context/AppConstants";
import * as AppState from "../context/AppState";
import { AppContext } from "../context/AppContext";
import { Collapsible } from '../components/Collapsible';
import { useSelector, useDispatch } from 'react-redux';
import { Divider } from 'react-native-paper';
import * as Linking from 'expo-linking';
import { useForm, Controller } from "react-hook-form";
import { CustomButton } from '../components/CustomButton';
import { TextInput } from 'react-native-paper';
import Markdown from 'react-native-markdown-display-fh';
import { HeaderLeft } from '../components/HeaderLeft';
import { SearchLauncher } from '../components/SearchLauncher';

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
    padding: 20,
  },
  heading: {
    fontSize: 18,
    fontWeight: "bold",
  },
  label: {
    fontSize: 14,
    fontWeight: "bold",
    paddingRight: 5,
    flexWrap: "wrap",
  },
  labelPadLeft: {
    fontSize: 18,
    fontWeight: "bold",
    paddingLeft: 10,
    paddingTop: 5,
  },
  normal: {
    fontSize: 14,
    paddingRight: 10,
    flexWrap: "wrap",
    flex: 1,
  },
  divider: {
    marginVertical: 15,
  },
  line: {
    flexDirection: "row",
    marginBottom: 15,
    flexShrink: 1,
  },
  line2: {
    flexDirection: "row",
    marginBottom: 25,
    marginTop: 10,
    flexShrink: 1,
  },
  line3: {
    flexDirection: "row",
    marginBottom: 15,
    flexShrink: 1,
    paddingLeft: 10,
  },
  listItemStyle: {
    paddingLeft: 5,
  },
  listItemLeftIcon: {
    marginRight: 0,
  },
  mainList: {
    flexGrow: 0,
  },
  kittemListItem: {
    backgroundColor: "transparent",
  },
  link: {
    color: "#0000EE",
    textDecorationLine: "underline",
  },
  subtitle: {
    marginVertical: 20,
    fontWeight: "600",
    color: "#6f6f6f",
  },
  subtitle2: {
    marginTop: 20,
    fontWeight: "600",
    color: "#6f6f6f",
  },
  legendWrapper: {
    flexDirection: "row",
    alignItems: "center",
  },
  legendTitle: {
    fontWeight: "bold",
    paddingLeft: 5,
    paddingBottom: 2,
  },
  legendSubtitle: {
    paddingLeft: 5,
  },
  listWrapper: {
    flexGrow: 1,
    padding: 10,
  },
  searchWrapper: {
    padding: 10,
    paddingTop: 0,
    minHeight: 75,
    //maxHeight: 300,
  },
  descriptionWrapper: {
    paddingHorizontal: 10,
  },
  errorView: {
    padding: 20,
  },
  topSection: {
    flex: 1,
    flexDirection: "row",
  },
  topSectionLeftContainer: {
    flex: 1,
  },
  topSectionRightContainer: {
  },
  topSectionRight: {
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  shareImage: {
    margin: 10,
    width: 25,
    height: 25,
  },
});

const markdownRules = {
  text: (node, children, parent, styles, inheritedStyles = {}) => (
    <Text key={node.key} style={[inheritedStyles, styles.text]} selectable={true}>
      {node.content}
    </Text>
  ),
};

const markdownStyles = StyleSheet.create({
  heading1: {
    paddingBottom: 10,
  },
  heading2: {
    paddingVertical: 10,
  },
});

function getYoutubeEmbedURL(link) {
  let result = "";
  if (link) {
    const v = link.indexOf("v=");
    if (v != -1) {
      link = link.substring(v + 2);
      result = "https://www.youtube.com/embed/" + link;
    }
  }
  return result;
}

function getVideoEmbed(link) {
  if (link) {
    if (link.indexOf("youtube.com") != -1) {
      if (AppUtilities.isWeb()) {
        return (
          <View style={AppConstants.STYLES.marginTop15}>
            <iframe width="100%" height="315" src={getYoutubeEmbedURL(link)} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
          </View>
        );
      }
    }
  }
  return null;
}

function isNormalLocation(route) {
  if (route.params.locationid) {
    return true;
  } else {
    return false;
  }
}

function isProducerLocation(route) {
  if (route.params.producer) {
    return true;
  } else {
    return false;
  }
}

const openShare = (name, link) => {
  Share.share(
    {
      message: link,
      url: link,
      title: name,
    },
    {
      dialogTitle: "Share Find Humane Link",
      subject: name,
    }
  );
};

export function LocationDetails({ route, navigation }) {
  const { showPermanentSnack, showTemporarySnack, hideSnack, getLoginState, showSpinner, hideSpinner } = React.useContext(AppContext);
  const globalSearch = useSelector((state) => state.searchLocation);
  const [filteredProducts, setFilteredProducts] = React.useState(null);
  const [anyPartial, setAnyPartial] = React.useState(false);
  const [details, setDetails] = React.useState({});
  const [loading, setLoading] = React.useState(true);
  const [errorText, setErrorText] = React.useState(null);
  const { width, height } = useWindowDimensions();
  const dataFilter = useSelector((state) => state.dataFilter);

  React.useEffect(() => {
    if (navigation) {
      return navigation.addListener("focus", () => {
        if (route && route.params && route.params.locationid) {
          AppUtilities.recordAppPageView("place/" + route.params.locationid);
        }
      });
    }
  }, [navigation]);

  React.useEffect(() => {
    if (navigation) {
      return navigation.addListener("blur", () => {
      });
    }
  }, [navigation]);

  async function loadLocationDetails(useFilter) {
    try {
      showSpinner();
      hideSnack();
      setLoading(true);

      AppUtilities.info("LocationDetails.loadLocationDetails fetching location details");

      const customizedDataFilter = Object.assign({}, dataFilter);
      let url = null;
      if (isNormalLocation(route)) {
        customizedDataFilter[AppConstants.SYNTHESIZED_TYPES.LOCATION_ID[AppConstants.TYPE_KEYS.URL_KEY]] = route.params.locationid;
        url = "/find_humane/api/get_location_details?" + AppUtilities.convertFilterHashToQueryParametersSorted(customizedDataFilter);
      } else if (isProducerLocation(route)) {
        customizedDataFilter[AppConstants.SYNTHESIZED_TYPES.PRODUCER[AppConstants.TYPE_KEYS.URL_KEY]] = route.params.producer;
        url = "/find_humane/api/get_producer_details?" + AppUtilities.convertFilterHashToQueryParametersSorted(customizedDataFilter);
      } else {
        throw new Error("Not implemented");
      }
      const response = await AppUtilities.fetchUnauthorized(
        "LocationDetails.loadLocationDetails",
        url,
        "GET",
        null,
        null,
        false,
        true,
      );

      if (AppUtilities.isStatusSuccess(response.status)) {
        if (response.body) {
          hideSpinner();

          //AppUtilities.info("LocationDetails.loadLocationDetails received: " + AppUtilities.toJSONPretty(response.body.details));

          navigation.setOptions({
            headerLeft: (props) => <HeaderLeft navigation={navigation} title={response.body.details.title} />,
            title: response.body.details.title,
          });
          if (response.body.products.find(product => product.partiallyhumane)) {
            setAnyPartial(true);
          }
          setDetails(response.body.details);
          //AppUtilities.dir(response.body.details);

          // If we're in the context of delivery services, then filter out products that
          // aren't available for delivery
          let products = response.body.products;
          if (route.params.online) {
            products = products.filter((product) => !product.notonline);
          }

          setFilteredProducts(products);
          setLoading(false);
          AppUtilities.info("LocationDetails.loadLocationDetails finished getting location details");
        } else {
          throw new Error("Result body not found");
        }
      } else {
        if (response.status == 404) {
          hideSpinner();
          const title = "404 Not Found";
          navigation.setOptions({
            headerLeft: (props) => <HeaderLeft navigation={navigation} title={title} />,
            title: title,
          });
          setLoading(false);
          setErrorText("Location has no currently known certified products");
        } else {
          AppUtilities.handleErrorStatus(response.status, response.responseText);
        }
      }
    } catch (e) {
      showPermanentSnack(AppUtilities.getErrors(e), "Retry", () => loadLocationDetails(useFilter));
      hideSpinner();
      AppUtilities.handleException(e, "LocationDetails.loadLocationDetails");
    }
  }

  React.useEffect(() => {
    if (dataFilter) {
      loadLocationDetails();
    }
  }, [dataFilter]);

  function getNavigationAddress() {
    if (details.address_navigate &&
        details.address_navigate.length > 0 &&
        details.address_navigate != details.address
       )
    {
      return details.address_navigate;
    } else {
      return details.title + ", " + details.address;
    }
  }

  async function openMaps() {
    try {
      AppUtilities.info("LocationDetails.openMaps: " + AppUtilities.toJSONPretty(details));
      if (AppUtilities.isWeb()) {
        window.open("https://maps.google.com/?q=" + encodeURIComponent(getNavigationAddress()), "_blank");
      } else if (AppUtilities.isIOS()) {
        Linking.openURL("maps:0,0?q=" + getNavigationAddress());
      } else {
        Linking.openURL("geo:0,0?q=" + getNavigationAddress());
      }
    } catch (e) {
      AppUtilities.handleException(e, "LocationDetails.openMaps");
    }
  }

  async function openNavigation() {
    try {
      AppUtilities.info("LocationDetails.openNavigation: " + AppUtilities.toJSONPretty(details));
      if (AppUtilities.isWeb()) {
        window.open("https://maps.google.com/maps?daddr=" + encodeURIComponent(getNavigationAddress()), "_blank");
      } else if (AppUtilities.isIOS()) {
        Linking.openURL("maps://app?daddr=" + getNavigationAddress());
      } else {
        Linking.openURL("google.navigation:q=" + getNavigationAddress());
      }
    } catch (e) {
      AppUtilities.handleException(e, "LocationDetails.openNavigation");
    }
  }

  function getWebsiteLink() {
    let link = details.website_underlying ? details.website_underlying : details.website;
    if (!details.linknoutm) {
      link = AppUtilities.getLinkWithUTM(link, AppConstants.UTM_CAMPAIGNS.LOCATION_DETAILS);
    }
    return link;
  }

  async function openWebsite() {
    try {
      AppUtilities.info("LocationDetails.openWebsite: " + AppUtilities.toJSONPretty(details));
      AppUtilities.openLink(getWebsiteLink());
    } catch (e) {
      AppUtilities.handleException(e, "LocationDetails.openWebsite");
    }
  }

  const { control, handleSubmit, reset, formState: { errors } } = useForm({
    defaultValues: {
      email: "",
      details: "",
    }
  });

  const { control: control2, handleSubmit: handleSubmit2, reset: reset2, formState: { errors: errors2 } } = useForm({
    defaultValues: {
      email: "",
      details: "",
    }
  });

  async function onSubmit(data) {
    try {
      showSpinner();
      hideSnack();

      await AppUtilities.fetchUnauthorized(
        "LocationDetails.onSubmit",
        "/find_humane/api/contact",
        "POST",
        {
          email: data.email,
          data: data.details,
          subject: "Report for " + details.title + " (" + details.id + ")",
        }
      );

      showTemporarySnack("Thanks! We'll review soon.");

      reset();

    } catch (e) {
      showPermanentSnack(AppUtilities.getErrors(e), "Retry", () => onSubmit(data));
      AppUtilities.handleException(e, "LocationDetails.onSubmit");
    } finally {
      hideSpinner();
    }
  }

  async function onSubmit2(data) {
    try {
      showSpinner();
      hideSnack();

      await AppUtilities.fetchUnauthorized(
        "LocationDetails.onSubmit2",
        "/find_humane/api/contact",
        "POST",
        {
          email: data.email,
          data: data.details,
          subject: "Add to " + details.title + " (" + details.id + ")",
        }
      );

      showTemporarySnack("Thanks! We'll review soon.");

      reset2();

    } catch (e) {
      showPermanentSnack(AppUtilities.getErrors(e), "Retry", () => onSubmit(data));
      AppUtilities.handleException(e, "LocationDetails.onSubmit2");
    } finally {
      hideSpinner();
    }
  }

  async function onValidationErrors(errors) {
    showTemporarySnack("There are some errors in the form");
  }

  function getGeneric(name, val, hideIfFalse, details) {
    if (hideIfFalse && !val) {
      return null;
    }
    return (
      <View style={details ? styles.line3 : styles.line}>
        <Text selectable={true} style={styles.label}>{name}:</Text>
        <Text selectable={true} style={styles.normal}>{val}</Text>
      </View>
    );
  }

  function getBoolean(name, val, hideIfFalse) {
    if (hideIfFalse && !val) {
      return null;
    }
    return (
      <View style={styles.line3}>
        <Text selectable={true} style={styles.label}>{name}:</Text>
        <Text selectable={true} style={styles.normal}>{val ? "Yes" : "No"}</Text>
      </View>
    );
  }

  const renderItem = ({ item, index }) => {
    return AppUtilities.renderProductRow(item, index, width);
  };

  const renderOnline = () => {
    let descriptionMarkdown = details.onlinedescription;

    if (details.deliversto) {
      descriptionMarkdown += "\n\n**Delivers to:** " + details.deliversto;
    }

    if (descriptionMarkdown && descriptionMarkdown.length > 0) {
      return (
        <>
          <Divider style={AppConstants.STYLES.marginVertical10} />
          <View style={styles.descriptionWrapper}>
            <Markdown style={markdownStyles} rules={markdownRules}>
              {
                descriptionMarkdown
              }
            </Markdown>
          </View>
          {
            details.website && !AppUtilities.isNullOrUndefined(details.website) ?
                <CustomButton
                  style={{ marginTop: 5, marginBottom: 10, marginLeft: 5 }}
                  onPress={() => AppUtilities.openLink(getWebsiteLink())}
                >
                  More Information / Buy
                </CustomButton>
              :
                null
          }
        </>
      );
    } else {
      return null;
    }
  };

  if (loading) {
    return null;
  }

  if (errorText) {
    return (
      <View style={styles.errorView}>
        <Text>{errorText}</Text>
      </View>
    );
  }

  return (
    <FlatList
      style={styles.mainList}
      keyboardShouldPersistTaps="handled"
      contentContainerStyle={styles.listWrapper}
      getItemLayout={AppUtilities.productListItemLayout}
      data={
        filteredProducts && filteredProducts.length > 0 ?
            filteredProducts.map((product) => (
              AppUtilities.createItemRow(
                product,
                () => {
                  navigation.navigate(
                    route.params.online ?
                      AppConstants.SCREENS.PRODUCT_ONLINE_DETAILS :
                      route.params.explore ?
                          AppConstants.SCREENS.PRODUCT_EXPLORE_DETAILS
                        :
                          AppConstants.SCREENS.PRODUCT_DETAILS,
                    {
                      productid: product.id,
                      online: route.params.online,
                      explore: route.params.explore,
                    }
                  );
                },
                (props) => (product.partiallyhumane ? <Image source={require('../../assets/circle-half-full-grey-25.png')} style={AppConstants.STYLES.image25x25} /> : null),
              )
            ))
          :
            [ { i: "-1", title: filteredProducts ? "No matches" : "Loading..." } ]
      }
      ItemSeparatorComponent={Divider}
      renderItem={renderItem}
      ListHeaderComponent={(
        <>
          <View style={styles.topSection}>
            <View style={styles.topSectionLeftContainer}>
              {
                details.title && details.title.length > AppConstants.HEADER_TEXT_OVERFLOW_LENGTH ?
                    getGeneric("Name", details.title ? details.title : "Loading...")
                  :
                    null
              }
              {
                !details.onlineonly && !AppUtilities.isNullOrUndefined(details.address) ?
                    <>
                      { getGeneric("Address", details.address) }
                      {
                        details.aspca_scorecard ?
                            <View style={styles.line}>
                              <Text selectable={true} style={styles.label}>ASPCA Scorecard:</Text>
                              {
                                AppUtilities.createLink(details.aspca_scorecard, "https://www.aspca.org/supermarketscorecard", AppConstants.UTM_CAMPAIGNS.LOCATION_DETAILS)
                              }
                            </View>
                          :
                            null
                      }
                      <View style={styles.line}>
                        <Pressable onPress={openMaps}>
                          <Image source={require('../../assets/google-maps-black-30.png')} style={AppConstants.STYLES.image30x30} />
                        </Pressable>
                        <Text selectable={true} style={styles.labelPadLeft} onPress={openMaps}>Open map</Text>
                      </View>
                      <View style={styles.line}>
                        <Pressable onPress={openNavigation}>
                          <Image source={require('../../assets/navigation-variant-outline-black-30.png')} style={AppConstants.STYLES.image30x30} />
                        </Pressable>
                        <Text selectable={true} style={styles.labelPadLeft} onPress={openNavigation}>Navigate</Text>
                      </View>
                    </>
                  :
                    null
              }
              {/*
                details.website && !AppUtilities.isNullOrUndefined(details.website) ?
                    <View style={styles.line}>
                      <Pressable onPress={openWebsite}>
                        <Image source={require('../../assets/web-black-30.png')} style={AppConstants.STYLES.image30x30} />
                      </Pressable>
                      <Text selectable={true} style={styles.labelPadLeft} onPress={openWebsite}>Open website</Text>
                    </View>
                  :
                    null
                */
              }
              {
                details.website && !AppUtilities.isNullOrUndefined(details.website) ?
                    renderOnline(details)
                  :
                    null
              }
            </View>
            <View style={styles.topSectionRightContainer}>
              <View style={styles.topSectionRight}>
                {
                  details ?
                      AppUtilities.isWeb() ?
                          AppUtilities.createLink(<Image source={require('../../assets/share-black.png')} style={styles.shareImage} />, "mailto:?subject=" + encodeURIComponent(details.title) + "&body=" + encodeURIComponent("Check out more humanely raised animal-based products at " + details.title + ": " + AppConstants.HOMEPAGE_LINK + "place/" + route.params.locationid))
                        :
                          <Pressable onPress={() => openShare(details.title, AppConstants.HOMEPAGE_LINK + "place/" + route.params.locationid)}>
                            <Image source={require('../../assets/share-black.png')} style={styles.shareImage} />
                          </Pressable>
                    :
                      null
                }
              </View>
            </View>
          </View>
          
          <Divider style={AppConstants.STYLES.marginTop5} />
          <Text style={styles.subtitle2}>Certified products (availability & prices may vary{details.online_shopping ? null : <Text>*</Text>})</Text>
          {
            filteredProducts && (filteredProducts.length >= 0 || !AppUtilities.isBlank(globalSearch) || AppConstants.IS_DEVELOPMENT) ?
                <View style={{ padding: 10 }}>
                  <SearchLauncher floating={false} hideSearchLocation={true} />
                </View>
              :
                null
          }
        </>
      )}
      ListFooterComponent={(
        <>
          <View style={{ paddingTop: filteredProducts && filteredProducts.length > 0 ? 20 : 0 }}>
            <Text>{filteredProducts && filteredProducts.length > 0 ? "Results: " + filteredProducts.length : ""}</Text>
          </View>
          {
            !details.online_shopping ? 
                <>
                  <Divider style={AppConstants.STYLES.marginVertical20} />
                  <View style={details ? styles.line3 : styles.line}>
                    <Text selectable={true} style={styles.label}>* </Text>
                    <Text selectable={true} style={styles.normal}>Availability & prices may vary.{
                      <Text> <Text style={styles.link} onPress={openMaps}>Call ahead</Text> to confirm availability.</Text>
                    }</Text>
                  </View>
                </>
              :
                null
          }
    
          {
            anyPartial ?
                <>
                  <Divider style={AppConstants.STYLES.marginVertical20} />
                  <Text style={styles.subtitle}>Legend</Text>
                  <View style={styles.legendWrapper}>
                    <Image source={require('../../assets/circle-half-full-grey-25.png')} style={AppConstants.STYLES.image25x25} />
                    <View>
                      <Text style={styles.legendTitle}>Partially humane</Text>
                      <Text style={styles.legendSubtitle}>Not all animal ingredients in the product are humanely certified</Text>
                    </View>
                  </View>
                </>
              :
                null
          }

          {
            details.supermarket ||
              details.restaurant ||
              details.foodtruck ||
              details.coffeeshop ||
              details.bakery ||
              details.bar ||
              details.dinein ||
              details.servesalcohol ||
              details.wifi ||
              details.wifipassword ||
              details.farm_store ||
              details.farm ||
              details.farmers_market ||
              details.csa ||
              details.farm_stay_bnb ||
              details.online_shopping ||
              details.onlineonly ||
              details.private_events ||
              details.workonlaptop ?
                <>
                  <Divider style={AppConstants.STYLES.marginTop15} />
                  <Text style={styles.subtitle}>Location details</Text>
                </>
              :
                null
          }
          { getBoolean("Farm", details.farm, true) }
          { getBoolean("Farm Store", details.farm_store, true) }
          { getBoolean("Farmers Market", details.farmers_market, true) }
          { getBoolean("Farm Stay & BnB", details.farm_stay_bnb, true) }
          { getBoolean("Grocery Store", details.supermarket, true) }
          { getBoolean("Restaurant", details.restaurant, true) }
          { getBoolean("Food Truck", details.foodtruck, true) }
          { getBoolean("Coffee Shop", details.coffeeshop, true) }
          { getBoolean("Bar", details.bar, true) }
          { getBoolean("Bakery", details.bakery, true) }
          { getBoolean("Dine-in", details.dinein, true) }
          { getBoolean("WiFi", details.wifi, true) }
          { getGeneric("WiFi Password", details.wifipassword, true, true) }
          { getBoolean("Place to work on laptop", details.workonlaptop, true) }
          { getBoolean("Serves alcohol", details.servesalcohol, true) }
          { getBoolean("Community-Supported Agriculture (CSA)", details.csa, true) }
          { getBoolean("Online Shopping", details.online_shopping, true) }
          { getBoolean("Only Online", details.onlineonly, true) }
          { getBoolean("Rentable for Private Events", details.private_events, true) }
          { getBoolean("Weddings", details.weddings, true) }
          { getBoolean("Butcher", details.butcher, true) }
          { getBoolean("General Store", details.generalstore, true) }
          { getBoolean("School", details.school, true) }
          { getBoolean("Non-profit", details.nonprofit, true) }
    
          {
            details.video_link ?
                <>
                  <Divider style={AppConstants.STYLES.marginTop15} />
                  <Text style={styles.subtitle}>Video</Text>
                  <View style={{ paddingLeft: 10 }}>
                    {
                      AppUtilities.createLink(details.video_link, details.video_link, AppConstants.UTM_CAMPAIGNS.LOCATION_DETAILS)
                    }
                    {
                      getVideoEmbed(details.video_link)
                    }
                  </View>
                </>
              :
                null
          }

          <Divider style={AppConstants.STYLES.marginVertical20} />
    
          <Collapsible title="Found a certified product here that we don't list?">
            <Controller
              control={control2}
              name="email"
              rules={{
                required: true,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <TextInput
                  label="Your email (in case of questions)"
                  value={value}
                  onChangeText={onChange}
                  style={AppConstants.STYLES.width100PmarginVertical10borderNone}
                  mode="outlined"
                  dense={true}
                  returnKeyType="next"
                  onBlur={onBlur}
                  autoComplete="email"
                  keyboardType="email-address"
                  textContentType="emailAddress"
                />
              )}
            />
            {errors2.email && <Text selectable={true} style={AppConstants.STYLES.fontBoldColorRed}>Email is required.</Text>}
    
            <Controller
              control={control2}
              name="details"
              rules={{
                //required: true,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <TextInput
                  label="Suggested product"
                  value={value}
                  onChangeText={onChange}
                  style={AppConstants.STYLES.width100PmarginVertical10borderNoneMinHeight}
                  mode="outlined"
                  dense={true}
                  returnKeyType="send"
                  onBlur={onBlur}
                  multiline={true}
                  numberOfLines={5}
                  textAlignVertical="top"
                />
              )}
            />
            {errors2.details && <Text selectable={true} style={AppConstants.STYLES.fontBoldColorRed}>Suggested product required.</Text>}
    
            <CustomButton
              onPress={handleSubmit2(onSubmit2, onValidationErrors)}
              style={AppConstants.STYLES.paddingVertical10}
            >Submit</CustomButton>
          </Collapsible>
    
          <Collapsible title="Report a problem or update">
            <Controller
              control={control}
              name="email"
              rules={{
                required: true,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <TextInput
                  label="Your email (in case of questions)"
                  value={value}
                  onChangeText={onChange}
                  style={AppConstants.STYLES.width100PmarginVertical10borderNone}
                  mode="outlined"
                  dense={true}
                  returnKeyType="next"
                  onBlur={onBlur}
                  autoComplete="email"
                  keyboardType="email-address"
                  textContentType="emailAddress"
                />
              )}
            />
            {errors.email && <Text selectable={true} style={AppConstants.STYLES.fontBoldColorRed}>Email is required.</Text>}
    
            <Controller
              control={control}
              name="details"
              rules={{
                //required: true,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <TextInput
                  label="Report"
                  value={value}
                  onChangeText={onChange}
                  style={AppConstants.STYLES.width100PmarginVertical10borderNoneMinHeight}
                  mode="outlined"
                  dense={true}
                  returnKeyType="send"
                  onBlur={onBlur}
                  multiline={true}
                  numberOfLines={5}
                  textAlignVertical="top"
                />
              )}
            />
            {errors.details && <Text selectable={true} style={AppConstants.STYLES.fontBoldColorRed}>Report required.</Text>}
    
            <CustomButton
              onPress={handleSubmit(onSubmit, onValidationErrors)}
              style={AppConstants.STYLES.paddingVertical10}
            >Submit</CustomButton>
          </Collapsible>
        </>
      )}
    />
  );
}
